import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import { handle_checkout_realtime_ticket_purchase } from "@/services/realtimeEventSecondHelper";

export default {
  components: {
    HomeNavBar,
  },
  mounted() {
    this.token_exists = get_token();
    this.fetchOrder();
    this.user_details = get_user_details();

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);
  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
  },

  data() {
    return ({
      token_exists: false,
      order: [],
      payfast: process.env.VUE_APP_PAYFAST_URL,
      user_details: {
        user_id: "",
      },
    });
  },
  methods: {
    handle_realtime_event(event) {
      handle_checkout_realtime_ticket_purchase(this, event);
    },
    getToken() {
      return get_token();
    },

     formatDateTime(datetime) {
    return new Date(datetime).toLocaleString();
  },

  completeEventPayment() {
    if (!this.order || !this.order.id) {
        Swal.fire({
          title: 'Order not found.',
          text: 'Please refresh and try again.',
          icon: 'warning',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
    }

    const order_id = this.$route.params.order_id;
    const user_id = this.user_details.user_id;

    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_payfast_event_payment/`,
        method: 'POST',
        data: JSON.stringify({
            user_id: user_id,
            order_id: order_id
        }),
        headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
        },
        success: (response) => {
                    if (response.success) {
                      var data_array = response.data_array;
                      var form = $('#payment_form');
                      for (var [key, value] of Object.entries(data_array)) {
                        var input = $('#input_clone').clone();
                        input.attr('name', key);
                        input.attr('value', value);  // Accessing value without square brackets
                        input.removeAttr('id');
                        input.removeClass('d-none');
                        form.append(input);
                    }
                      Swal.fire({
                          title: 'Success',
                          icon: 'success',
                          text: "Redirecting to PayFast in a few seconds don't close this page",
                          showConfirmButton: false,
                          position: 'bottom-end',
                          timer: 3000,
                          toast: true
                      })
                      form.submit();
                  }
                  },
        error: (error) => {
            console.error('AJAX error:', error);
            Swal.fire({
              title: 'Error',
              text: 'Payment failed. Please try again later.',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
        }
    });
},

    fetchOrder() {
      const order_id = this.$route.params.order_id;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_purchase_order/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: {
          order_id: order_id
        },
        success: (response) => {

          this.order = response.order_data;

        },
        error: (xhr) => {
          console.error("Failed to fetch order:", xhr.responseText);
        },
      });
    },
  }
}
